import { render, staticRenderFns } from "./SelectDossier.vue?vue&type=template&id=87d83aa2"
import script from "./SelectDossier.vue?vue&type=script&lang=ts"
export * from "./SelectDossier.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87d83aa2')) {
      api.createRecord('87d83aa2', component.options)
    } else {
      api.reload('87d83aa2', component.options)
    }
    module.hot.accept("./SelectDossier.vue?vue&type=template&id=87d83aa2", function () {
      api.rerender('87d83aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectDossier.vue"
export default component.exports